export default __webpack_public_path__ + "static/OperatorMono-Medium-a5100de571727eaa5793c6b3db6e9940.woff2";